export const SIGN_OUT_FAILURE =
  'Your session may still be active. Try signing out again before leaving this device.'

/** Return to sign-in only after revocation; callers must surface failures. */
export async function signOutAndRedirect(
  logout: () => Promise<void>,
  assign: (url: string) => void = (url) => window.location.assign(url),
  loginUrl = '/login',
  confirmDiscard: () => Promise<boolean> = async () => true,
): Promise<void> {
  if (!(await confirmDiscard())) return
  await logout()
  assign(loginUrl)
}
